<template>
  <validation-observer ref="observer" tag="fieldset">
    <b-card-body>
      <b-row>
        <b-col>
          <distribution-form-group
            id="hold"
            vid="hold"
            ref="hold"
            :description="$t('hold_help_text') | capitalize"
            :label="$t('hold') | capitalize"
            label-cols="2"
            v-slot="{ state }"
            >
              <b-form-select v-model="distribution.hold" :options="holdOptions" :state="state"/>
          </distribution-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <distribution-form-group
            id="notes"
            vid="notes"
            ref="notes"
            :description="$t('notes_help_text') | capitalize"
            :label="$t('notes') | capitalize"
            label-cols="2"
            v-slot="{ state }"
            >
              <b-form-textarea v-model="distribution.notes" :state="state"/>
          </distribution-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2" v-if="isMoratoriumPerformer">
        <b-col>
          <distribution-form-group
            vid="moratoriumPerformer"
            ref="moratoriumPerformer"
            :description="$t('moratorium_help_text') | capitalize"
            :label="`${$t('moratorium_minimum')} (${$t('performer')})` | capitalize"
            label-cols="2"
            :rules="getMoratoriumRules(distribution.moratoriumPerformerMinimumType)"
            :detect-input="false"
            v-slot="{ state, validate }"
            @hook:mounted="validate(distribution.moratoriumPerformerMinimum)"
          >
            <b-input-group>
              <template v-slot:append>
                <b-form-select :options="moratoriumTypeOptions" v-model="distribution.moratoriumPerformerMinimumType" @change="validate(distribution.moratoriumPerformerMinimum)"/>
              </template>
              <b-form-input v-model="distribution.moratoriumPerformerMinimum" :state="state" @input="validate"></b-form-input>
            </b-input-group>
          </distribution-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-2" v-if="isMoratoriumMaker">
        <b-col>
          <distribution-form-group
            vid="moratoriumMaker"
            ref="moratoriumMaker"
            :description="$t('moratorium_help_text') | capitalize"
            :label="`${$t('moratorium_minimum')} (${$t('maker')})` | capitalize"
            label-cols="2"
            :rules="getMoratoriumRules(distribution.moratoriumMakerMinimumType)"
            :detect-input="false"
            v-slot="{ state, validate }"
            @hook:mounted="validate(distribution.moratoriumMakerMinimum)"
          >
            <b-input-group>
              <template v-slot:append>
                <b-form-select :options="moratoriumTypeOptions" v-model="distribution.moratoriumMakerMinimumType" @change="validate(distribution.moratoriumMakerMinimum)"/>
              </template>
              <b-form-input v-model="distribution.moratoriumMakerMinimum" :state="state" @input="validate"></b-form-input>
            </b-input-group>
          </distribution-form-group>
        </b-col>
      </b-row>
    </b-card-body>
  </validation-observer>
</template>

<script>
import DistributionFormGroup from "@/components/DistributionFormGroup"
import { ValidationObserver } from "vee-validate"
import { capitalize } from "lodash"
import { distributionCollegeTypes } from "@/constants"
import { distributionSectionMixin } from "@/utils/mixins"
import { moratoriumValueTypes } from "@/constants"


export default {
  name: "OtherSection",
  components: { DistributionFormGroup, ValidationObserver },
  mixins: [ distributionSectionMixin ],
  props: {
    distribution: Object
  },
  data () {
    return {
      holdOptions: Object.values(distributionCollegeTypes).map(v => ({ value: v, text: capitalize(this.$t(v)) })),
      moratoriumTypeOptions: [
        {
          text: "%",
          value: moratoriumValueTypes.PERCENT,
        },
        {
          text: "CAD",
          value: moratoriumValueTypes.MONEY,
        }
      ]
    }
  },
  computed : {
    isMoratoriumMaker () {
      const makerTypes = [distributionCollegeTypes.MAKER, distributionCollegeTypes.MAKER_AND_PERFORMER]
      return this.distribution?makerTypes.includes(this.distribution.college):false
    },
    isMoratoriumPerformer () {
      const performerTypes = [distributionCollegeTypes.PERFORMER, distributionCollegeTypes.MAKER_AND_PERFORMER]
      return this.distribution?performerTypes.includes(this.distribution.college):false
    }
  },
  methods : {
    getMoratoriumRules (type) {
      if (type === moratoriumValueTypes.PERCENT) {
        return "double|min_value:0|max_value:100"
      } else if (type === moratoriumValueTypes.MONEY) {
        return "double|positive"
      }
      return ""
    }
  },
  emits: ["update:distribution"],
  watch: {
    "distribution.college" (newVal) {
      const updated = { ...this.distribution }
      if (newVal === distributionCollegeTypes.MAKER) {
        updated.moratoriumPerformerMinimumType = null
        updated.moratoriumPerformerMinimum = null
      } else if (newVal === distributionCollegeTypes.PERFORMER) {
        updated.moratoriumMakerMinimumType = null
        updated.moratoriumMakerMinimum = null
      }
      this.$emit("update:distribution", updated)
    }
  }
}
</script>
